
import { defineComponent } from "vue";
import store from "@/store/index";
import { PadelGame } from "@/models/padelGame.interface";
import { getFullPlayerNames } from "@/services/htmlHelperService";
import { evenScore, removeNotNumbers } from "@/services/scoreService";
import { GameSide } from "@/models/gameSide.enum";

export default defineComponent({
    methods: {
        onCalculateScore(): void {
            store.dispatch.americanoStore.updatePlayerScores();
            store.commit.americanoStore.INCREMENT_STEP();
        },
        IsNewRound(index: number, amountOfGames: number) {
            return index % (amountOfGames / 7) === 0;
        },
        getPlayerNames(game: PadelGame, side: GameSide) {
            return getFullPlayerNames(game, side);
        },
        shouldHaveTopBorder(game: PadelGame) {
            const lastTwoGamesOfFour = game.matchNumber == 2;
            const secondGameOfFour =
                game.playGroup == 2 && game.matchNumber == 1;
            return lastTwoGamesOfFour || secondGameOfFour;
        },
        goBack(): void {
            store.dispatch.americanoStore.sortPlayersById();
            store.commit.americanoStore.DECREMENT_STEP();
        },
        reset(): void {
            store.commit.americanoStore.RESET();
        },
        handleFocusChange(game: PadelGame, side: GameSide) {
            removeNotNumbers(
                game,
                side,
                store.getters.americanoStore.getRules.maxScore
            );
            evenScore(
                game,
                store.getters.americanoStore.getRules.maxScore,
                side
            );
            store.dispatch.americanoStore.saveStateManually();
        },
        getColorCodeGroup(game: PadelGame) {
            if (store.getters.americanoStore.getRules.colorCode === false) {
                return 0;
            }

            return game.playGroup;
        },
        isEven(index: number) {
            return index % 2 == 0;
        },
        getCourt(index: number) {
            const rules = this.getRules;
            if (rules.courtNames) return rules.courtNames[index];
            return "";
        },
        printCourt(index: number) {
            if (this.getRules.amountOfPlayers === 16) return "";

            if (this.isEven(index)) return this.getCourt(0) || "Bana 1";

            return this.getCourt(1) || "Bana 2";
        },
    },
    computed: {
        getGames() {
            return store.getters.americanoStore.getGames;
        },
        getRules() {
            return store.getters.americanoStore.getRules;
        },
    },
});
